import { Pipe, PipeTransform } from '@angular/core';
import { DOC_TYPES } from '../model/consts/document-modal.consts';

@Pipe({
  name: 'documentType'
})
export class DocumentTypePipe implements PipeTransform {

  transform(value: string): string {
    return DOC_TYPES.find((docType) => docType.id === value)?.displayValue || value;
  }

}
